import session from '@updater-core/interactors/shell/session';
import { createGateway as createRemoteGateway } from '@updater-core/gateways/remote-storage';
import { createGateway as createLocalGateway } from '@updater-core/gateways/local-storage';
import { buildOptimizely } from './interactor';

export default buildOptimizely({
  interactors: { session },
  gateways: {
    createRemoteGateway,
    createLocalGateway,
  },
  url: typeof document !== 'undefined' ? document.location : '',
});
